export function getTakenOverLessonIds(
  lessons: { id: string; assigned_teacher_id?: string | null }[],
  teacherId: string | null | undefined,
): string[] {
  if (!teacherId) return []
  return lessons
    .filter(lesson => lesson.assigned_teacher_id === teacherId)
    .map(lesson => lesson.id)
}
